/* layal-ajout-rapide.js : panneau d'ajout rapide d'un autre produit (snippets/layal-ajout-rapide.liquid).
 *
 * - Bouton -> <dialog> modal (tiroir par le bas sur téléphone, panneau latéral sur ordinateur), Échap ou × ferme.
 * - Formule choisie (Solo, Duo, Trio… ou Voile seul, 3 voiles…) : une rangée de coloris par article ; les articles
 *   suivent le 1er tant que la visiteuse ne les change pas ; image = coloris du dernier choix.
 * - Ajout : window.Layal.lignesPourLot (variante seule, ou produit lot à prix fixe avec « Coloris 1 »… comme le bloc
 *   d'achat de ce produit) puis window.Layal.ajouterAuPanier (tiroir panier du thème, mêmes événements). Le panneau se
 *   ferme une fois l'ajout fait ; une erreur reste affichée dans le panneau.
 */
(function () {
  "use strict";

  function $(sel, racine) { return (racine || document).querySelector(sel); }
  function $$(sel, racine) { return Array.prototype.slice.call((racine || document).querySelectorAll(sel)); }

  function init(zone) {
    if (zone.dataset.lpArPret) return;
    var dialogue = $("[data-lp-ar]", zone);
    var ouvrir = $("[data-lp-ar-ouvrir]", zone);
    var donnees = null;
    try { donnees = JSON.parse($("[data-lp-ar-donnees]", zone).textContent); } catch (e) { donnees = null; }
    if (!dialogue || !ouvrir || !donnees || typeof dialogue.showModal !== "function") return;
    zone.dataset.lpArPret = "1";

    var coloris = donnees.coloris || [];
    var parId = {};
    coloris.forEach(function (c) { parId[c.id] = c; });
    var formules = (donnees.formules || []).filter(function (f) { return f.quantite === 1 || (f.varianteLot && f.disponible); });
    var premier = coloris.filter(function (c) { return c.disponible; })[0] || coloris[0];
    var etat = { formule: 0, couleurs: [], touche: [] };
    for (var i = 0; i < 5; i++) { etat.couleurs[i] = premier && premier.id; etat.touche[i] = false; }

    var listeFormules = $("[data-lp-ar-formules]", dialogue);
    var zoneRangees = $("[data-lp-ar-rangees]", dialogue);
    var modele = $("[data-lp-ar-modele]", dialogue);
    var image = $("[data-lp-ar-img]", dialogue);
    var bouton = $("[data-lp-ar-ajouter]", dialogue);
    var prixBouton = $("[data-lp-ar-prix]", dialogue);
    var erreur = $("[data-lp-ar-erreur]", dialogue);
    var statut = $("[data-lp-ar-statut]", dialogue);
    var id = dialogue.id;
    function prix(centimes) { return window.Layal && window.Layal.formatMonnaie ? window.Layal.formatMonnaie(centimes, donnees.formatMonnaie) : (centimes / 100).toFixed(2) + " €"; }

    // Formules : boutons radio (nom et prix).
    formules.forEach(function (f, k) {
      var label = document.createElement("label");
      label.className = "lp-ar__formule";
      var input = document.createElement("input");
      input.type = "radio";
      input.name = id + "-formule";
      input.value = String(k);
      input.checked = k === 0;
      input.addEventListener("change", function () { if (input.checked) { etat.formule = k; rendreRangees(); maj(); } });
      var span = document.createElement("span");
      var nom = document.createElement("strong");
      nom.textContent = f.nom;
      var montant = document.createElement("small");
      montant.setAttribute("data-lp-ar-prix-formule", String(k));
      span.appendChild(nom);
      span.appendChild(montant);
      label.appendChild(input);
      label.appendChild(span);
      listeFormules.appendChild(label);
    });

    function formule() { return formules[etat.formule] || formules[0]; }
    function prixFormule(f) {
      if (!f) return 0;
      if (f.quantite > 1) return Number(f.prix) || 0;
      var c = parId[etat.couleurs[0]];
      return c ? Number(c.prix) || 0 : 0;
    }

    // Rangées de coloris : une par article de la formule (modèle <template> rendu par le thème).
    function rendreRangees() {
      var q = formule() ? formule().quantite : 1;
      zoneRangees.textContent = "";
      for (var r = 0; r < q; r++) {
        var fragment = modele.content.cloneNode(true);
        var rangee = fragment.querySelector("fieldset");
        $("[data-lp-ar-libelle]", rangee).textContent = q > 1 ? (donnees.article || "Article") + " " + (r + 1) : "Coloris";
        $$("input", rangee).forEach(function (input) {
          var c = parId[input.value];
          input.name = id + "-rang-" + r;
          input.disabled = !c || !c.disponible;
          input.checked = input.value === etat.couleurs[r];
          (function (rang) {
            input.addEventListener("change", function () { if (input.checked) choisir(rang, input.value); });
          })(r);
        });
        zoneRangees.appendChild(fragment);
      }
      majNoms();
    }
    function majNoms() {
      $$(".lp-ar__rangee", zoneRangees).forEach(function (rangee, r) {
        var c = parId[etat.couleurs[r]];
        $("[data-lp-ar-nom]", rangee).textContent = c ? c.nom : "";
      });
    }
    function choisir(rang, cle) {
      etat.couleurs[rang] = cle;
      if (rang === 0) { for (var k = 1; k < 5; k++) if (!etat.touche[k]) etat.couleurs[k] = cle; }
      else etat.touche[rang] = true;
      $$(".lp-ar__rangee", zoneRangees).forEach(function (rangee, r) {
        $$("input", rangee).forEach(function (input) { input.checked = input.value === etat.couleurs[r]; });
      });
      var c = parId[cle];
      if (image && c && c.image && image.getAttribute("src") !== c.image) image.src = c.image;
      majNoms();
      maj();
    }
    function maj() {
      formules.forEach(function (f, k) {
        var el = $("[data-lp-ar-prix-formule='" + k + "']", listeFormules);
        if (el) el.textContent = prix(prixFormule(f));
      });
      var f = formule();
      var q = f ? f.quantite : 1;
      var pret = !!f;
      for (var r = 0; r < q; r++) { var c = parId[etat.couleurs[r]]; if (!c || !c.disponible || !c.variante) pret = false; }
      bouton.disabled = !pret;
      prixBouton.textContent = pret ? " · " + prix(prixFormule(f)) : "";
    }

    function ajouter() {
      var f = formule();
      if (!f || bouton.disabled || bouton.getAttribute("aria-busy") === "true") return;
      var couleurs = [];
      for (var r = 0; r < f.quantite; r++) couleurs.push(parId[etat.couleurs[r]]);
      erreur.hidden = true;
      erreur.textContent = "";
      var lignes;
      try {
        lignes = window.Layal.lignesPourLot({ quantite: f.quantite, varianteLot: f.varianteLot, disponible: f.quantite === 1 || f.disponible }, couleurs);
      } catch (e) {
        erreur.textContent = e.message;
        erreur.hidden = false;
        return;
      }
      bouton.setAttribute("aria-busy", "true");
      window.Layal.ajouterAuPanier(lignes, bouton).then(function () {
        statut.textContent = "Ajouté au panier : " + f.nom + ", " + couleurs.map(function (c) { return c.nom; }).join(", ") + ".";
        apresAjout = true; // le tiroir panier s'ouvre : il garde le focus
        dialogue.close();
      }, function (err) {
        erreur.textContent = (err && err.message) || "Le panier n'a pas pu être mis à jour.";
        erreur.hidden = false;
      }).then(function () { bouton.removeAttribute("aria-busy"); });
    }

    ouvrir.addEventListener("click", function () {
      erreur.hidden = true;
      dialogue.showModal();
      ouvrir.setAttribute("aria-expanded", "true");
    });
    var apresAjout = false;
    dialogue.addEventListener("close", function () {
      ouvrir.setAttribute("aria-expanded", "false");
      // Focus rendu au bouton qui a ouvert le panneau (bloc d'achat ou autre déclencheur de la page).
      var retour = zone._lpArRetour || ouvrir;
      zone._lpArRetour = null;
      if (!apresAjout) retour.focus();
      apresAjout = false;
    });
    $("[data-lp-ar-fermer]", dialogue).addEventListener("click", function () { dialogue.close(); });
    // Clic sur le fond (hors du panneau) : fermeture.
    dialogue.addEventListener("click", function (e) {
      if (e.target !== dialogue) return;
      var b = dialogue.getBoundingClientRect();
      if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialogue.close();
    });
    bouton.addEventListener("click", ajouter);
    ouvrir.setAttribute("aria-expanded", "false");
    rendreRangees();
    maj();
  }

  function demarrer() { $$("[data-lp-ajout-rapide]").forEach(init); }
  // Autres déclencheurs de la page (ex. mini-section « Le maintien Layal », data-lp-ar-declencheur) : ouvrent le
  // panneau ; sans panneau, le lien mène à la fiche du produit.
  document.addEventListener("click", function (e) {
    var lien = e.target.closest && e.target.closest("[data-lp-ar-declencheur]");
    if (!lien) return;
    var ouvrir = $("[data-lp-ajout-rapide] [data-lp-ar-ouvrir]");
    if (!ouvrir) return;
    e.preventDefault();
    ouvrir.closest("[data-lp-ajout-rapide]")._lpArRetour = lien;
    ouvrir.click();
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
  document.addEventListener("shopify:section:load", demarrer);
})();
